// TODO: there's a bunch of stuff in the render method that can probably be cleaned up

import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DATE_FORMAT_URL } from '../../../data/constants/datetime';
import { useUpdateWhenScheduleAdvances } from '../../../data/hooks/datetimeHooks';
import { useAutoOpenableLiveVoting } from "../../../data/hooks/voting/useAutoOpenableLiveVoting";
import { eventMomentFactory } from '../../../data/misc/eventMomentFactory';
import LoadProgram from '../../loaders/LoadProgram';
import ErrorBoundary from '../../validate/ErrorBoundary';
import WaitWhileBusy from '../../WaitWhileBusy';
import NextProgram from '../common/NextProgram';
import SupportIcon from '../common/SupportIcon/SupportIcon';
import LiveVotingButton from '../common/Toolbar/LiveVotingButton';
import SidePanelToolbar from '../common/Toolbar/SidePanelToolbar';
import SidePanelWrapper from '../SidePanelWrapper';
import ExternalSideStream from './ExternalSideStream';
import './ExternalSource.scss';
import ToggleSideStream from './ToggleSideStream';
import VirtualRoomFrame from './VirtualRoomFrame';

// TODO: remove eventSettings prop (it's easily available inside event)
const ExternalSource = (props) => {
    const { eventSettings, maximize, eventId, event, nextProgram, currentProgram, onOpenVirtualRoom, sideStreamURL, i18n } = props,
        voting = useAutoOpenableLiveVoting(eventId, currentProgram?.id)[0], // linked voting sessions + program-less voting sessions
        [hideSideStream, setHideSideStream] = useState(false),
        [showToggleSideStream, setShowToggleSideStream] = useState(false),
        [restoredLeftSide, setRestoredLeftSide] = useState(false);

    // make sure some updates are called
    useUpdateWhenScheduleAdvances(eventId);

    // restore left side when program gets to the end
    useEffect(() => {
        if (currentProgram && moment().isAfter(currentProgram.end_utc) && !restoredLeftSide && currentProgram.session_content_url != nextProgram?.session_content_url) {
            app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
            setRestoredLeftSide(true);
        }
    });
    useEffect(() => {
        setRestoredLeftSide(false);
    }, [currentProgram]);

    // Auto open live voting
    useEffect(() => {
        if (voting) {
            const votingPath = ['/events', event.id, 'schedule', eventMomentFactory(event, currentProgram?.start_local).format(DATE_FORMAT_URL), currentProgram?.id, 'livevoting', voting?.id].join(
                '/'
            );
            if (votingPath != app.history.location.pathname && voting.is_open) {
                app.history.push(`${votingPath}?autoclose=1&previous=${app.history.location.pathname}`);
                app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
            } else if (voting.is_open) {
                app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
            }
        }
    }, [voting?.id, voting?.is_open]);

    const handleToggleFullScreen = () => {
        app.store.dispatch(app.actions.ui.sidePanel.toggleMaximize());
    };

    const modalContext = {
        i18n,
        primary_color: event.settings.primary_color,
        programId: nextProgram ? nextProgram.id : null,
        eventId: event.id,
        ...nextProgram,
        onOpenVirtualRoom,
    };
    return (
        <SidePanelWrapper>
            <div className={['externalSource', sideStreamURL && maximize ? 'hasSideStream' : '', hideSideStream ? 'hideSideStream' : ''].join(' ')} style={{ background: eventSettings.primary_color }}>
                <SidePanelToolbar onClose={() => handleCloseVirtualRoom(eventId)}>
                    {currentProgram && voting?.is_open ? <LiveVotingButton event={event} programItem={currentProgram} votingSession={voting} /> : null}
                    <SupportIcon style={{}} />
                </SidePanelToolbar>
                {sideStreamURL ? (
                    <>
                        <ExternalSideStream url={sideStreamURL} onFocusChange={setShowToggleSideStream} />
                        <ToggleSideStream event={event} visible={hideSideStream || showToggleSideStream} onClick={() => setHideSideStream(!hideSideStream)} />
                    </>
                ) : null}
                <VirtualRoomFrame />
                <NextProgram event={event} timeLimit={5} />
            </div>
        </SidePanelWrapper>
    );
};

function handleCloseVirtualRoom() {
    app.store.dispatch(app.actions.ui.sidePanel.reset());
}

function getSecondsToEnd(endDate) {
    if (endDate) {
        const seconds = moment(endDate).diff(moment(), 'seconds');
        return seconds >= 0 ? seconds : 0;
    }
}
export const StateConnectedExternalSource = connect(function (state, props) {
    let nextProgram, nextMeeting;
    const { eventId } = props,
        programId = state.ui.sidePanel.virtualRoom?.programId,
        meetingId = state.ui.sidePanel.virtualRoom?.meetingId,
        currentVirtualRoomProgram = programId && state.events[eventId].schedule.indexed[programId],
        currentVirtualRoomMeeting = meetingId && _(state.events[eventId].meetings.all).find((meeting) => meeting.id == meetingId);

    // TODO: also list next meeting if there is one before the next program

    if (currentVirtualRoomProgram) {
        // Filter to get the next programme to show as a message.
        nextProgram = _(state.events[eventId]?.schedule.all || [])
            .reject(
                (p) =>
                    moment(p.start_utc).diff(currentVirtualRoomProgram.end_utc, 'minutes') < 0 ||
                    new Date(p.end_utc).valueOf() < currentVirtualRoomProgram.end_utc ||
                    p.display_category ||
                    //   (p.is_selectable && p.round_id > 0) ||
                    //   (p.is_selectable && p.is_selected)
                    (p.is_selectable && !p.is_selected)
            )
            .sortBy('start_utc')
            .first();
    }

    // let url;
    // if (currentVirtualRoomProgram) {
    //     url = _.get(currentVirtualRoomProgram, 'session_content_url', null);
    // } else if (currentVirtualRoomMeeting) {
    //     url = _.get(currentVirtualRoomMeeting, 'virtualroom_url', null);
    // }
    // console.log(url);

    return {
        event: state.events[eventId].event,
        eventSettings: state.events[eventId].event.settings,
        i18n: state.i18n.translations,
        currentProgram: currentVirtualRoomProgram,
        currentMeeting: currentVirtualRoomMeeting,
        sideStreamURL: currentVirtualRoomProgram ? currentVirtualRoomProgram.sidestream_url : null,
        maximize: state.ui.sidePanel.maximize,
        nextProgram,
        nextMeeting,
        eventId,
    };
})(ExternalSource);

export default (props) => {
    const params = props.match.params;

    return (
        <LoadProgram eventId={params.eventId}>
            <WaitWhileBusy alt={<span />}>
                <ErrorBoundary altComponent={false}>
                    <StateConnectedExternalSource {...params} />
                </ErrorBoundary>
            </WaitWhileBusy>
        </LoadProgram>
    );
};
